// extracted by mini-css-extract-plugin
export default {"infoIcon":"AssociateGroup_infoIcon__4a9zk"};